export default {"src":"/_next/static/media/menu.d689559e.svg","height":32,"width":32};